import React from 'react'
import {Form, Icon, Popup } from 'semantic-ui-react'
import GridSearchTemplate from '../../../pages/GridSearchTemplate';
import {DatePicker} from '../../shared/DatePicker';
import  {useTextResources } from '../../../language';
import HotelsDropDown from '../../shared/HotelsDropDown';
import CustomerDropDown from '../../shared/CustomerDropDown';
import GuestSearchDropDown from '../../shared/GuestSearchDropDown';
import TextInput from '../../shared/TextInput';
import { Reports, Print } from '../../../api/services/next';
import { endpoint } from '../../../api/http';
import moment from 'moment';
import RoomsDropDown from '../../shared/RoomsDropDown';
import CheckboxWrapper from '../../shared/Checkbox';
import { dateFormat } from '../../shared/constants';

const InvoicesReceiptsReport = ()=>{

    const CustomersSpec = React.useMemo(() => {
        return {
          GetOnlyCustomerArray: true,
          IsActive: true,
          IncludeCustomerTypeId: true,
        };
    }, []);

    const reservationFormatter = ({value, row})=>{
        return value != '0'?<a target="_blank" rel="noopener noreferrer" href={`${endpoint}PMS/Reservations/Index/${row.ReservationId}?hotelid=${row.HotelId}`}>{value}</a>:null
    }
    const folioFormatter = ({value, row})=>{
        return <a target="_blank" rel="noopener noreferrer" href={`${endpoint}Finance/Folio/Folio?FolioId=${row?.FolioId}?hotelid=${row?.HotelId}`}>{value}</a>
    }
    const guestFormatter = ({value, row})=>{
        return <a target="_blank" rel="noopener noreferrer" href={`${endpoint}CRM/GuestProfile/index/#/profile/${row?.GuestId}?hotelid=${row?.HotelId}`}>{value}</a>
    }

    const currencyFormatter = ({ value }) => {
        return value ? value.toFixed(2) : (0).toFixed(2)
    }

    const customizeExcelHeader = worksheet=>{
        const row = worksheet.addRow([`Invoices and Receipts Report`])
        worksheet.mergeCells('A1:O1');
        row.height = 20
        row.font = { bold: true, size: 16 };
    }

    const dateFormatter = ({value})=>{
        return value&&moment(value).format(dateFormat) || ""
    }

    const actionsFormatter = ({row})=>{
        const isInvoice = row.Type === "Invoices"
        return <Popup trigger={<Icon link name="print" onClick={async ()=>{
            var result = await isInvoice?Print.PrintInvoice(row.Id, text("CopyInvoice")):Print.PrintReceipt(row.Id)
            console.log(result)
        }}/>} content={isInvoice?text("PrintInvoiceCopy"):text("PrintReceipt")}/>
    }

    const infoFormatter = ({row})=>{
        if (row.Receipts?.length){
            return <div>
                <span>{text("Receipts")}: </span>
                {row.Receipts.map(value=>{
                    return folioFormatter({value, row})
                })}
            </div>
        } else if (row.CreditCardInformation) {
            return <div>
                <span>{`${text("CreditCard")}: ${row.CreditCardInformation.LastFourDigits} ${row.CreditCardInformation.ExpirationDate}`}</span>
            </div>
        }
        return "";
    }
    const text = useTextResources()
    const gridOptions = {
        search: {
            title: "Invoices and Receipts Report",
            fields: [ 
                <Form.Field placeholder={text("All")} multiple clearable control={HotelsDropDown} label="Hotel" key="HotelIds"/>,
                <DatePicker 
                    type="basic"
                    label= {text("StartDate")} 
                    name="StartDate"
                    key="FromDate"
                />,
                <DatePicker 
                    type="basic"
                    label= {text("EndDate")}
                    name="EndDate"
                    key="ToDate"
                />,
                <Form.Field
                    label={text('Room')}
                    placeholder={text('All')}
                    multiple
                    control={RoomsDropDown}
                    key="RoomIds"
                    clearable
                />,
                <Form.Field
                  key='GuestId'
                  label={text('Guest')}
                  width={3}
                  clearable
                  allowAdditions={false}
                  control={GuestSearchDropDown}
                  placeholder={text('SearchByNameEmailPhoneId')}
                />,
                <Form.Field
                key='CustomerId'
                label={text('Customer')}
                placeholder={text('All')}
                width={3}
                clearable
                control={CustomerDropDown}
                spec={CustomersSpec}
              />,
              <Form.Field
                key='ReservationNumber'
                label={text('ReservationNumber')}
                control={TextInput}
                />,
                <Form.Field
                key='InvoiceNumber'
                label={text('InvoiceNumber')}
                control={TextInput}
                />,<Form.Field
                key='ReceiptNumber'
                label={text('ReceiptNumber')}
                control={TextInput}
                />,
                <CheckboxWrapper
                    label= {text("CreditCardPayment")}
                    key="CreditCardInfo"
                />
            ],
            method: 'POST',
            api: Reports.InvoicesReceiptsReport
        },
        grid: {
            columns: [
                { name: 'Type', title: 'Type' },
                { name: 'Hotel', title: text('Hotel') },
                { name: 'Number', title: text('Number') , formatter: folioFormatter},
                { name: 'ReservationNumber', title: text('ReservationNumber') , formatter: reservationFormatter},
                { name: 'Guest', title: text('Guest') , formatter: guestFormatter},
                { name: 'Nationality', title: text('Nationality') },
                { name: 'GuestIdentityCardNumber', title: text('GuestIdentityCardNumber') },
                { name: 'Customer', title: text('Customer') },
                { name: 'RoomNumber', title: text('RoomNumber') },
                { name: 'BusinessDate', title: text('BusinessDate') , formatter: dateFormatter},
                { name: 'AmountBeforeTax', title: text('AmountBeforeTax'), formatter: currencyFormatter },
                { name: 'AmountTax', title: text('Tax'), formatter: currencyFormatter },
                { name: 'AmountAfterTax', title: text('AmountAfterTax'), formatter: currencyFormatter },
                { name: 'ArrivalDate', title: text('ArrivalDate') , formatter: dateFormatter},
                { name: 'DepartureDate', title: text('DepartureDate') , formatter: dateFormatter},
                { name: 'Action', title: text('Action'), formatter: actionsFormatter},
                { name: 'Info', title: text('AdditionalInformation'), formatter: infoFormatter}
            ],
            paging: true,
            cacheId: 'InvoiceReceipts',
            customOptions:{
            group:{
                grouping: [{ columnName: 'Type' }],
                defaultExpandedGroups: ["Invoices","Receipts"]
                }
            },
            summary: true,
            scrollbarX: true,
            groupSummaryItems: [
                { columnName: 'AmountBeforeTax', type: 'sum', showInGroupFooter: false, alignByColumn: true },
                { columnName: 'AmountTax', type: 'sum', showInGroupFooter: false, alignByColumn: true},
                { columnName: 'AmountAfterTax', type: 'sum', showInGroupFooter: false, alignByColumn: true},
            ],
            export: true,
            excel: {
                customizeHeader: customizeExcelHeader,
                grouping:  [{ columnName: "Type" }],
                groupSummaryItems: [
                    { columnName: "AmountBeforeTax", type: 'sum' },
                    { columnName: "AmountTax", type: 'sum' },
                    { columnName: "AmountAfterTax", type: 'sum' }
                ],
            },
        }
    }
    return (<GridSearchTemplate options={gridOptions} />)
}

export default InvoicesReceiptsReport